import React from 'react';
import { ListItemText } from '@mui/material';
import { capitalizeFirstLetter } from '../documentViewHelpers';
import SelectedListItemText from '../SelectedListItemText';

export default function TocItemText({ isPageShowing, title }) {
    const contents = capitalizeFirstLetter(title);

    return isPageShowing ? <SelectedListItemText>{contents}</SelectedListItemText> : <ListItemText>{contents}</ListItemText>;
}